import darkClosedFolder from './folder-dark-closed.png';
import darkOpenFolder from './folder-dark-open.png';
import lightClosedFolder from './folder-light-closed.png';
import lightOpenFolder from './folder-light-open.png';

export const ASSET_LIBRARY_FOLDER_IMAGES = {
  dark: {
    closed: darkClosedFolder.src,
    open: darkOpenFolder.src,
  },
  light: {
    closed: lightClosedFolder.src,
    open: lightOpenFolder.src,
  },
} as const;
